import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["password", "toggleButton", "eyeOpen", "eyeClosed"]

  toggle() {
    // Toggle the type attribute
    const type = this.passwordTarget.type === 'password' ? 'text' : 'password';
    this.passwordTarget.type = type;

    // Toggle the eye icon visibility using classList for Tailwind compatibility
    if (type === 'password') {
      // Password is hidden - show "closed eye" (click to reveal)
      this.eyeOpenTarget.classList.add('hidden');
      this.eyeClosedTarget.classList.remove('hidden');
    } else {
      // Password is visible - show "open eye" with slash (click to hide)
      this.eyeOpenTarget.classList.remove('hidden');
      this.eyeClosedTarget.classList.add('hidden');
    }
  }
}
